module.exports = __webpack_public_path__ + "static/media/magnette.fb64fa71.jpg";